import { render, staticRenderFns } from "./Ppbkl.vue?vue&type=template&id=a0ceecce"
import script from "./Ppbkl.vue?vue&type=script&lang=js"
export * from "./Ppbkl.vue?vue&type=script&lang=js"
import style0 from "./Ppbkl.vue?vue&type=style&index=0&id=a0ceecce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports